import { cn } from '../utils/cn';

interface WordmarkProps {
	/** Size + color per surface, e.g. "text-sm text-white" or "text-[13px] text-neutral". */
	className?: string;
}

/**
 * Wordmark — the canonical Naumu text logo.
 *
 * Locks the brand typographic identity (heavy weight, lowercase, slightly tight
 * tracking) and the literal string so every header/footer renders an identical
 * logo. Callers set only size and color per surface via `className` (dark vs
 * light, 13px vs 14px) — never the weight, case, or tracking.
 */
export function Wordmark({ className }: WordmarkProps): React.JSX.Element {
	return (
		<span className={cn('font-[700] lowercase tracking-[-0.015em]', className)}>
			naumu
		</span>
	);
}
